import React from 'react';
import { InformationCircleIcon, CloseIcon, WarningToastIcon } from '@assets/icon';
import './GlobalToast.scss';

export interface ToastMessage {
  id?: string;
  text: string;
  type: 'success' | 'error' | 'info' | 'cskh';
  actionLabel?: string;
  onAction?: () => void;
  title?: string;
  timeLabel?: string;
  hideIcon?: boolean;
}

interface GlobalToastProps {
  message: ToastMessage | null;
  onClose: () => void;
}

const shouldShowErrorIcon = (message: ToastMessage | null): boolean => {
  if (!message || message.hideIcon) return false;
  if (message.text === 'Bạn chưa có quyền sử dụng micro. Vui lòng bật lại trong browser settings') {
    return false;
  }
  return message.type === 'error';
};

const GlobalToast: React.FC<GlobalToastProps> = ({ message, onClose }) => {
  if (!message || message.type === 'cskh') return null;

  return (
    <div key={message.id} className={`global-toast toast-${message.type}`}>
      <div className="global-toast-content">
        {shouldShowErrorIcon(message) && <WarningToastIcon className="toast-warning-icon" />}
        {message.type === 'info' && <InformationCircleIcon className="toast-info-icon" />}

        <div className="toast-main-content">
          <span className="toast-text">{message.text}</span>
          {message.onAction && (
            <button
              className="toast-action-btn"
              onClick={message.onAction}
              type="button"
            >
              {message.actionLabel || 'Xem chi tiết'}
            </button>
          )}
        </div>

        <div className="toast-divider" />

        <button
          className="global-toast-close"
          onClick={onClose}
          type="button"
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

export default GlobalToast;
